<template>
  <div>
    
    

  </div>
</template>

<script>
// -- import something here --

export default {

  data: () => ({
  }),

  mounted() {
    console.log("Home Page");
  },

  methods: {
    
  },

};
</script>

<style lang="scss">
@import '~scss/main';


</style>


